import Drawer from 'flowbite/lib/esm/components/drawer/index';

export const manageDrawer = function (drawerId, drawerButtonId, drawerCloseId, options = {}) {
    const $targetElement = document.getElementById(drawerId);
    const $drawerButtonElement = document.getElementById(drawerButtonId);
    const $drawerCloseElement = document.getElementById(drawerCloseId);
    if (!$targetElement || !$drawerButtonElement) {
        return;
    }

    // Flowbite marks the closed drawer aria-hidden but leaves its links tabbable, so keyboard
    // focus walked into an invisible off-canvas menu. `inert` is the attribute that actually
    // removes them from the tab order.
    const deactivate = () => $targetElement.setAttribute('inert', '');
    const activate = () => $targetElement.removeAttribute('inert');

    // The drawer starts closed.
    deactivate();

    const drawerOptions = {
        ...options,
        placement: 'left',
        backdrop: true,
        bodyScrolling: false,
        edge: false,
        edgeOffset: '',
        backdropClasses: 'bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-drawer-background',
        onHide: () => {
            deactivate();
            options.onHide?.();
        },
        onShow: () => {
            activate();
            options.onShow?.();
        }
    };

    const drawerElement = new Drawer($targetElement, drawerOptions);

    $drawerButtonElement.addEventListener('click', () => {
        // Before show(), never after: if onShow ever failed to fire, an inert drawer would be a
        // mobile menu that opens and cannot be touched.
        activate();
        drawerElement.show();
    });
    if ($drawerCloseElement) {
        $drawerCloseElement.addEventListener('click', () => {
            drawerElement.hide();
        });
    }

    return drawerElement;
};
